import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable, from, switchMap } from 'rxjs';
import { AuthService } from '../../services/auth/auth.service';

@Injectable()
export class TokenRenewalInterceptor implements HttpInterceptor {
  private isRenewing = false;

  constructor(private authService: AuthService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Verifica se existe um token
    const token = localStorage.getItem('token');
    if (!token) {
      return next.handle(request);
    }

    try {
      // Decodifica o token JWT para verificar a expiração
      const tokenData = JSON.parse(atob(token.split('.')[1]));
      const currentTime = Math.floor(Date.now() / 1000);
      
      // Se o token estiver próximo de expirar (menos de 5 minutos) e não estiver renovando
      if (tokenData.exp - currentTime < 300 && !this.isRenewing) {
        this.isRenewing = true;
        
        return from(this.authService.authExpired()).pipe(
          switchMap((response: any) => {
            this.isRenewing = false;
            if (response && response.token) {
              localStorage.setItem('token', response.token);
              const renewedRequest = request.clone({
                setHeaders: {
                  Authorization: `Bearer ${response.token}`
                }
              });
              return next.handle(renewedRequest);
            }
            throw new Error('Falha ao renovar token');
          })
        );
      }

      // Adiciona o token em todas as requisições
      const authenticatedRequest = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
      return next.handle(authenticatedRequest);
    } catch (error) {
      this.isRenewing = false;
      return next.handle(request);
    }
  }
} 